import { createAsyncThunk } from '@reduxjs/toolkit'
import CoherentScreen from './coherent-screen-model'
import {
  delete_coherentScreen,
  load_coherentScreens,
  store_coherentScreen,
} from './coherentScreen-service'

export const LoadCoherentScreensAsync = createAsyncThunk<any, any>(
  'composer/load/coherentScreen',
  async (params: { uid: string }) => {
    return await load_coherentScreens(params)
  },
)

export const CreateCoherentScreenAsync = createAsyncThunk<any, any>(
  'composer/create/coherentScreen',
  async (params: CoherentScreen) => {
    return await store_coherentScreen(params)
  },
)

export const DeleteCoherentScreenAsync = createAsyncThunk<any, any>(
  'composer/delete/coherentScreen',
  async (params) => {
    return await delete_coherentScreen(params)
  },
)
